module.exports = __webpack_public_path__ + "static/designPatternsIntro2-1f4a1ddea46a65022a4257c5823a1ee3.png";